import React, { Component } from 'react'
import service from '../../services';
import Loader from '../loader';
import moment from 'moment-timezone'
import FilterActiveIcon from '../../icons/filteractiveicon';
import FilterIcon from '../../icons/filtericon';
import serachIcon from './../../assets/images/search.svg'
import ReactPaginate from 'react-paginate';
let programFilterList = []

let sub;
export default class Reservation extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
            programArray:[],
            getScreeningList:[],
            searchField:'',
              // pagination variable diclaration start
            offset: 0,
            perPage: 50,
            currentPage: 0,
            totalPages:0,
            // pagination variable diclaration end
        }
        this.apiserve = new service();
    }

    
    componentWillUnmount = () => {
        sub.unsubscribe();
        programFilterList=[];
    }

    
    componentDidMount = async () => {
        this.apiserve.sendevent("user|sff|getAllInitialForRedis", {});
        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "admin|screening|getList":
                    if(!response.error){
                            this.setState({
                                getScreeningList: response.data.docs,
                                getTotalDocs: response.data.totalDocs,
                                pageCount: Math.ceil(response.data.totalDocs / this.state.perPage),
                            }, () => {
                                this.setState({ 
                                    loaderFlag: false,
                                    dateFilterModal:false
                                 })
                            })
                    }else{
                        this.apiserve.error(response.data.error ? response.data.error : response.data)
                    }
                    break;
                    case "user|sff|getAllInitialForRedis":
                        var programData =  response.data.film && response.data.film.category.map(function (el) {
                             let o = Object.assign({}, el);
                             o.value = false;
                             return o;
                         });
                         this.setState({
                             programArray:programData
                         })
                    break;
                default:
                    break;
            }
        });


        this.getReservation(this.state.offset, this.state.perPage);
        this.setState({
            loaderFlag: true,
        });
    }

    getReservation = (skip, limit) => {

        this.setState({
            loaderFlag:true
        })
        var data = {}
        if(this.state.searchField.length){
            data.filter = this.state.searchField
        }

        // if(roleWiseFilterData.length){
        //     data.role= roleWiseFilterData
        // }

        if (programFilterList && programFilterList.length) {
            data.category = programFilterList
        }
        
        data.page = skip
        data.limit = limit
        this.apiserve.sendevent("admin|screening|getList",data);
    }

    programFilter = (e, selectedInex,isClearStatusType ,isClearProgramType = false) => {
        let index = selectedInex
        let event = e && e.target && e.target.checked
        let approvePassList = [...this.state.programArray]
        approvePassList.forEach((key, i) => {
        if(i === index) {
            approvePassList[i].value = event
        }
        if(isClearProgramType) {
            approvePassList[i].value = false
            programFilterList=[]
        }
        
        })
        this.setState({
            ...this.state,
            programArray: approvePassList,
            currentPage:0
        },()=> {
            if (event) {
                if (index !== null) {
                    programFilterList = [...programFilterList, this.state.programArray[index]._id];
                }         
                
        } else {
            if (index !== null) {
                let tempArray = programFilterList.filter((d) => d !== this.state.programArray[index]._id);
                programFilterList = tempArray; 
            }
        }
        this.getFilmFilter(this.state.offset, this.state.perPage,isClearStatusType,isClearProgramType);
        })
    }

    getFilmFilter = (skip,limit,isClearStatusType,isClearProgramType) =>{
        
        let data = {
            page: 1,
            limit: limit
        }
    
        if (!isClearProgramType && programFilterList && programFilterList.length) {
            data.category = programFilterList
        }
     
        this.apiserve.sendevent("admin|screening|getList", data);
    }

    //Search Data
    onSearchFilter = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
            currentPage:0
        }, () => {
            var data = {
                page: 1,
                limit: 50,
            }
            if(this.state.searchField.length){
            data.filter = this.state.searchField
            }
            if (programFilterList && programFilterList.length) {
                data.category = programFilterList
            }
            this.apiserve.sendevent("admin|screening|getList",data);
        });
    }

     //Pagination Click
     handlePageClick = (e) => {
        const selectedPage = e.selected;
        const offset = selectedPage + 1;
        this.setState(
            {
                currentPage: selectedPage,
                offset: offset,
                loaderFlag: true
            },
            () => {
                this.getReservation(offset, this.state.perPage,this.state.searchField,programFilterList);
            }
        );
    };
    
    render() {
        const {getScreeningList,programArray} = this.state
        
        return (
            <>
                <div class="film_list_table striped_table reservation_tbl">
                    <table className="tbl_layout_fix">
                    <thead>
                        <tr>
                            <th style={{width: "325px"}}>
                                <div class="dashboard_header no_bg p_0">
                                    <div class="searchBlock back_date pl_15">
                                        <form class="m_0">
                                            <input class="bg_white" type="text" placeholder="Search" id="searchField" name="searchField"  value={this.state.searchField}
                                                onChange={this.onSearchFilter}  />
                                            <button type="button" ><img src={serachIcon} /></button>
                                        </form>
                                    </div>
                                </div>
                            </th>
                            <th style={{width: "165px"}}>
                            <span className="disp_flex d_flex_align_center">Program 
                                    {programFilterList && programFilterList.length ?
                                        <FilterActiveIcon /> 
                                        :
                                        <FilterIcon /> 
                                    }
                                </span> 

                                   
                                <div className="tabelData_popup">
                                        <form>
                                            <div className="customCheck">
                                                <div className="customCheckBox clear_all_popup d_flex d_flex_justify_spacebt">
                                                    <p className="link" onClick={()=>this.programFilter(null,null,null,true)}>Clear All</p>
                                                </div>
                                                
                                                <div className="customCheckBox">
                                                {programArray.map((item,i)=>(
                                                    <div className="customCheckBox">
                                                    <input
                                                        type="checkbox"
                                                        id={item._id}
                                                        name={item._id}
                                                        value={item.value ? true : false}
                                                        checked={item.value ? true : false}
                                                        onClick={(e) => this.programFilter(e, i)}
                                                    />
                                                    <label htmlFor={item._id}>{item.name}</label>
                                                    </div>
                                                    ))
                                                }
                                                </div>
                                                </div>
                                        </form>
                                    </div> 
                            </th>
                        
                            <th style={{width: "140px"}}>Date-Time (MT)</th>
                            <th style={{width:"170px"}}></th>
                            <th style={{width:"170px"}}></th>
                            <th style={{width:"90px"}}>Allowed</th>
                            <th style={{width:"75px"}}>Opted</th>
                            <th style={{width:"90px"}}>Consumed</th>
                            <th style={{width:"130px"}}></th>
                            <th style={{width:"90px"}}>Allowed</th>
                            <th style={{width:"75px"}}>Opted</th>
                            <th style={{width:"90px"}}>Consumed</th>
                        </tr>
                    </thead>
                    <tbody>
                        {getScreeningList.map((item)=>{
                               let shortProgramme = new Date(item.shortProgramme && item.shortProgramme.date)
                            return(
                                <tr class="pointer" style={{borderBottom:"18px solid #E5E5E5"}}>
                                    <td style={{width: "325px"}}>
                                        <div class="disp_flex">
                                            <div class="film_banner"><img src={
                                                item && item.images && item.images.inSite ? this.apiserve.imageUrl + item.images.inSite :
                                                item && item.images && item.images.link ? item.images.link :
                                                     '/images/image-placeholder.png'
                                                } /></div>
                                            <div class="film_desc">
                                                <h3>{item.title}</h3>
                                                <div class="disp_flex d_flex_align_center"><span>{item.runTime} min</span><span class="btn_label">500</span></div>
                                            </div>
                                        </div>
                                    </td>
                                    <td style={{width: "165px"}}>
                                        <div><p>{item && item.category && item.category.name}</p></div>
                                    </td>
                                    
                                    <td style={{width: "190px"}}>
                                        <div>
                                        { item.dateTime && item.dateTime.length >= 1 ? 
                                            item.dateTime.map((date) => {
                                            return(
                                            <p>{moment(date.date).tz("US/Mountain").format('MMM DD - h:mm A')}</p>
                                            )
                                            })
                                            :
                                            item.shortProgramme && item.shortProgramme.date ?
                                            <p>{moment(shortProgramme).format('MMM DD')} - {moment(shortProgramme).format("h:mm A")}</p>
                                            : '-'
                                    }
                                        </div>
                                    </td>
                                {item && item.category && item.category.type === 1 ?
                                <>
                                <td style={{width:"170px"}} className="bg_white">
                                    <div className="d_flex d_flex_justify_center d_flex_align_center">
                                        <div className="mt_15 text_center">
                                            <p className="font_700 mb_10">Total Allowed</p>
                                            <h2>{item && item.screening && item.screening.total}</h2>
                                        </div>
                                    </div>
                                </td>
                                <td style={{width:"170px"}} className="dark_gray p_0" >
                                        <table className="w_100 h_100 reservation_inner_tbl" width="100">
                                            <tr>
                                                <td className="dark_gray"><p className="font_600">Premiere Tickets</p></td>
                                            </tr>
                                            <tr>
                                                <td className="dark_gray"><p className="font_600">Public Passholder Reservations</p></td>
                                            </tr>
                                            <tr>
                                                <td className="dark_gray"><p className="font_600">Industry Reservations</p></td>
                                            </tr>
                                        </table>
                                </td>
                                <td style={{width:"90px"}} className="bg_white p_0">
                                        <table className="w_100 h_100 reservation_inner_tbl" width="100">
                                        <tr> 
                                            <td className="bg_white border_btm_2"><h3>{item && item.screening && item.screening.premierTickets && item.screening.premierTickets.allowed}</h3></td> </tr>
                                            <tr> <td className="bg_white border_btm_2"><h3>{item && item.screening && item.screening.publicPassHolder && item.screening.publicPassHolder.allowed}</h3></td> </tr>
                                            <tr> <td className="bg_white"><h3>{item && item.screening && item.screening.industryReservation && item.screening.industryReservation.allowed}</h3></td> </tr>
                                        </table>
                                </td>
                             
                                <td style={{width:"75px"}} className="lightgreen p_0">
                                        <table className="w_100 h_100 reservation_inner_tbl" width="100">
                                            <tr>
                                                <td className="lightgreen border_btm_2"><h3>{item && item.screening && item.screening.premierTickets && item.screening.premierTickets.opted} </h3></td>
                                            </tr>
                                            <tr>
                                                <td className="lightgreen border_btm_2"><h3>{item && item.screening && item.screening.publicPassHolder && item.screening.publicPassHolder.opted}</h3></td>
                                            </tr>
                                            <tr>
                                                <td className="lightgreen"><h3>{item && item.screening && item.screening.industryReservation && item.screening.industryReservation.opted} </h3></td>
                                            </tr>
                                        </table>
                                </td>
                                <td style={{width:"90px"}} className="fieldbgorg p_0">
                                        <table className="w_100 h_100 reservation_inner_tbl" width="100">
                                            <tr>
                                                <td className="fieldbgorg border_btm_2"><h3>{item && item.screening && item.screening.premierTickets && item.screening.premierTickets.consumed} </h3></td>
                                            </tr>
                                            <tr>
                                                <td className="fieldbgorg border_btm_2"><h3>{item && item.screening && item.screening.publicPassHolder && item.screening.publicPassHolder.consumed}</h3></td>
                                            </tr>
                                            <tr>
                                                <td className="fieldbgorg"><h3>{item && item.screening && item.screening.industryReservation && item.screening.industryReservation.consumed} </h3></td>
                                            </tr>
                                        </table>
                                </td>
                                <td style={{width:"130px"}} className="dark_gray p_0">
                                        <table className="w_100 h_100 reservation_inner_tbl" width="100">
                                            <tr> <td className="dark_gray"><p className="font_600">Catch Up Access</p></td> </tr>
                                            <tr> <td className="dark_gray"><p className="font_600">Catch Up Tickets</p></td> </tr>
                                            <tr> <td className="dark_gray"><p className="font_600">Award Winner</p></td> </tr>
                                        </table>
                                    </td> 
                                    <td style={{width:"90px"}} className="bg_white p_0">
                                        <table className="w_100 h_100 reservation_inner_tbl" width="100">
                                            <tr>
                                                <td className="bg_white border_btm_2"><h3>{item && item.screening && item.screening.premierTickets && item.screening.catchUpAccess.allowed} </h3></td>
                                            </tr>
                                            <tr>
                                                <td className="bg_white border_btm_2"><h3>{item && item.screening && item.screening.premierTickets && item.screening.catchUpTickets.allowed}</h3></td>
                                            </tr>
                                            <tr>
                                                <td className="bg_white"><h3>{item && item.screening && item.screening.premierTickets && item.screening.awardWinner.allowed} </h3></td>
                                            </tr>
                                        </table>
                                </td>
                                <td style={{width:"75px"}} className="dark_gray p_0">
                                        <table className="w_100 h_100 reservation_inner_tbl" width="100">
                                            <tr>
                                                <td className="dark_gray border_btm_2"><h3> </h3></td>
                                            </tr>
                                            <tr>
                                                <td className="lightgreen border_btm_2"><h3>{item && item.screening && item.screening.premierTickets && item.screening.catchUpTickets.opted}</h3></td>
                                            </tr>
                                            <tr>
                                                <td className="dark_gray"><h3></h3></td>
                                            </tr>
                                        </table>
                                </td>
                                <td style={{width:"90px"}} className="fieldbgorg p_0">
                                        <table className="w_100 h_100 reservation_inner_tbl" width="100">
                                            <tr>
                                                <td className="fieldbgorg border_btm_2"><h3>{item && item.screening && item.screening.premierTickets && item.screening.catchUpAccess.consumed} </h3></td>
                                            </tr>
                                            <tr>
                                                <td className="fieldbgorg border_btm_2"><h3>{item && item.screening && item.screening.premierTickets && item.screening.catchUpTickets.consumed}</h3></td>
                                            </tr>
                                            <tr>
                                                <td className="fieldbgorg"><h3>{item && item.screening && item.screening.premierTickets && item.screening.awardWinner.consumed} </h3></td>
                                            </tr>
                                        </table>
                                </td>
                                </>
                                :
                                <>
                                 <td style={{width:"170px"}} className="bg_white">
                                    <div className="d_flex d_flex_justify_center d_flex_align_center">
                                        <div className="mt_15 text_center">
                                            <p className="font_700 mb_10">Total Allowed</p>
                                            <h2>{item && item.screening && item.screening.total}</h2>
                                        </div>
                                    </div>
                                </td>
                                <td style={{width:"170px"}} className="dark_gray" >
                                        <table className="w_100 h_100 reservation_inner_tbl" width="100">
                                            <tr>
                                                <td className="p_5 dark_gray"><p className="font_600">VOD CONSUMED</p></td>
                                            </tr>
                                            <tr>
                                                <td className="p_5 dark_gray"></td>
                                            </tr> 
                                            <tr>
                                                <td className="p_5 dark_gray"></td>
                                            </tr>
                                        </table>
                                </td>
                                <td style={{width:"90px"}} className="fieldbgorg">
                                        <table className="w_100 h_100 reservation_inner_tbl" width="100">
                                            <tr>
                                                <td className="p_5 fieldbgorg"><h3>{item && item.screening && item.screening.consumed} </h3></td>
                                            </tr>
                                            <tr>
                                                <td className="p_5 fieldbgorg"></td>
                                            </tr>
                                            <tr>
                                                <td className="p_5 fieldbgorg"></td>
                                            </tr>
                                        </table>
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                </>
                             }
                            </tr>
                            )
                        })}
                       
                    </tbody>
                </table>
                </div>
                {/* Pagination View Display */}
                {getScreeningList.length && getScreeningList ? (
                    <div className="custom-pagination">
                        <ReactPaginate
                            previousLabel={""}
                            nextLabel={""}
                            breakLabel={"..."}
                            breakClassName={"break-me"}
                            pageCount={this.state.pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={this.handlePageClick}
                            containerClassName={"pagination"}
                            subContainerClassName={"pages pagination"}
                            activeClassName={"active"}
                            forcePage={this.state.currentPage}
                        />
                    </div>
                ) : (
                    ""
                    )}

                {this.state.loaderFlag ? (
                    <Loader />
                ) : (
                        ""
                    )}
            </>
        )
    }
}
